import {
  getApiUrl
} from "./chunk-XEDCQDS7.mjs";

// src/utils/log-manager.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["DEBUG"] = "DEBUG";
  LogLevel2["INFO"] = "INFO";
  LogLevel2["WARN"] = "WARN";
  LogLevel2["ERROR"] = "ERROR";
  return LogLevel2;
})(LogLevel || {});
var LogManager = class {
  constructor(env, id, rp) {
    this.environment = env;
    this.correlationId = id;
    this.relyingParty = rp;
  }
  setLogDetails(logDetails) {
    this.logDetails = logDetails;
  }
  /* eslint-disable @typescript-eslint/require-await -- Logs must be Async to prevent blocking */
  async log(logLevel, logMsg) {
    try {
      const logRequest = {
        payload: logMsg,
        "logging-level": logLevel
      };
      const loggingUrl = `${getApiUrl(this.environment)}/v1/client/logs`;
      let pcidUuid = "";
      if (typeof localStorage !== "undefined") {
        pcidUuid = localStorage.getItem("pcid_uuid") || "";
      }
      fetch(loggingUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "relying-party": this.relyingParty,
          "x-forwarded-for": this.logDetails?.sourceIps || "",
          source: "WEB",
          "user-agent": this.logDetails?.userAgent || "",
          "x-correlation-id": this.correlationId,
          "pcid-uuid": pcidUuid
        },
        body: JSON.stringify(logRequest)
      }).catch((_error) => {
      });
    } catch (error) {
      console.error("Error logging message:", error);
    }
  }
};

export {
  LogLevel,
  LogManager
};
